import { defineComponent as r, createElementBlock as t, openBlock as a, normalizeStyle as n, renderSlot as o } from "vue";
const c = /* @__PURE__ */ r({
  __name: "SidebarGroup",
  props: {
    level: {}
  },
  setup(e) {
    return (l, s) => (a(), t("ul", {
      class: "sidebar-group sidebar-indent-nested",
      style: n({ "--scalar-sidebar-level": e.level })
    }, [
      o(l.$slots, "default")
    ], 4));
  }
});
export {
  c as default
};
